module.exports = __webpack_public_path__ + "static/media/logo-novida-header.0549e193.svg";